import { render, staticRenderFns } from "./SundryCreditorVendor.vue?vue&type=template&id=3a4b9999"
import script from "./SundryCreditorVendor.vue?vue&type=script&lang=js"
export * from "./SundryCreditorVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports